export var imageRenditions = {
  desktopL: {
    h: '582',
    w: '916'
  },
  desktop: {
    h: '480',
    w: '782'
  },
  tabletL: {
    h: '480',
    w: '584'
  },
  tabletP: {
    h: '442',
    w: '540'
  },
  mobile: {
    h: '200',
    w: '320'
  }
};